<template>
    <div>
        <member-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter" :areaList="areaList"></member-filter-link>
        <member-list-link :memberData="List" :listLayout="listLayout"></member-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"
                         :listLength="List.length"></pagination-link>
    </div>
</template>

<script>
    import filterMixins from "@/mixins/filterMixins";
    import listMixins from "@/mixins/listMixins";
    import alertMixin from "@/mixins/alertMixin";
    import MemberListLink from "@/components/member/MemberListLink";
    import memberUtil from "@/components/member/memberUtil";
    import PaginationLink from "@/components/member/PaginationLink";
    import MemberFilterLink from "@/components/member/MemberFilterLink";
    const {filterConfig} = memberUtil;

    export default {
        name: "MemberListComponent",
        mixins: [filterMixins, listMixins, alertMixin, memberUtil],
        components: {MemberListLink, PaginationLink, MemberFilterLink},
        props: {
            memberType: '',
        },
        provide() {
            return {
                setPage: this.setPage,
                setFilter: this.setFilter,
                memberListSetData: this.setData,
            }
        },
        data() {
            return {
                listLayout: '',
                paginationLayout: '',
                filterLayout: '',
                getFunc: '',
                listApiParamSet: {},
                pageRow: 10,

                areaList: [],

                /*필터 classname*/
                filterSi:'',
            }
        },
        beforeRouterEnter() {
        },
        created() {
            this.setFilterConfig(filterConfig)
            this.initConfig()
            this.setParserType('url', this.$route.fullPath);
        },
        mounted() {
            this.getList(true);
            this.getAreaList()
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            initConfig() {
                let memberConfig = this.returnMemberConfig(this.memberType);
                this.listLayout = memberConfig.listLayout;
                this.filterLayout = memberConfig.filterLayout;
                this.listApiParamSet = memberConfig.listApiParamSet;
                this.getFunc = memberConfig.getFunc;
                this.paginationLayout = memberConfig.paginationLayout;

                let pageRow = memberConfig.pageRow ? memberConfig.pageRow : 10;

                if (pageRow != this.filterSet.page.size) {
                    this.filterSet.page.size = pageRow;
                }

                let listOptions = {
                    url: this.$api.$member[this.getFunc],
                    defaultParams: this.listApiParamSet,
                }
                this.initList('api', listOptions);
            },

            setData(key, value) {
                this[key] = value;
            },
            getAreaList() {
                let params = {si: 1}
                try {
                    this.$api.$area.getArea(params).then(res => res.Data.Result).then(res => {
                        let type = this.returnAreaType(res.Info.type)
                        if (type === true) {
                            this.areaList = res.List
                        }
                        else {
                            this.errorAlert(type)
                        }
                    })
                } catch (e) {
                    console.log(e)
                }
            },
            returnAreaType(type){
                switch (type) {
                    case 1:
                        return true
                    default:
                        return '지역 리스트를 불러올 수 없습니다.'
                }
            }

        },
        watch: {},
    }
</script>

<style scoped>

</style>